// Generated by scripts/reefModel.ts from art/hawaii-reef/ (M110); do not edit. Rebuild: npm run reef-model.
import url from '../models/reef.glb?url';

/** The reef's model, the user's Hawaiian reef kit (`art/hawaii-reef/`), as the game carries it: its address once built. */
export const REEF_MODEL_URL: string = url;
